module.exports = __webpack_public_path__ + "static/media/asahi-mizuno-win.f18d2f28.jpg";